<template>
  <div class="main">
    <a-spin class="load" v-show="loading"/>
    <div class="top">
      <div class="title">
        <span class="t-l">学前准备</span>
        <span class="t-r flex-row">
          <div @click="goBeiKe()" style="margin:auto 5px auto 5px;"><span class="use-his">备课历史</span> </div>
          <a-divider type="vertical" style="margin: auto 5px auto 5px;"/>
          <div @click="goZiYuan()" style="margin: auto 5px auto 5px;"><span class="pre">备课资源</span> </div>
          <span @click="orderRelease" type="primary" class="has-ep">发布</span>
          <!--          <span  @click="goStudent" type="primary" class="has-ep">学生端预览</span>-->
        </span>
      </div>
      <div class="left">
        <div class="content">
          <div class="bgc" v-for="(item, index) in prepareData" :key="index">

            <div class="message" v-html="item.content" style="white-space: pre-wrap;text-align: justify"></div>
            <div class="imgView">
              <div v-if="item.imageList != null" style="text-align:left;">
                <!--                <a-carousel arrows dots-class="slick-dots slick-thumb" :autoplay="autoplay">-->
                <!--                  <a slot="customPaging" slot-scope="props">-->
                <!--                    <img style="object-fit: cover;" :src="resBasePath + '/' + item.imageList[props.i].path"/>-->
                <!--                  </a>-->
                <!--                </a-carousel>-->

                <!--                <div class="flex-row" style="overflow: auto">-->
                <!--                  <div v-for="img in item.imageList" :key="img.id" @click="preview(img)" style="text-align: center">-->
                <!--                    <img class="img-height" :src="resBasePath + '/' + img.path"/>-->
                <!--                    <p v-if="img.name" style="text-align: center">{{ img.name }}</p>-->
                <!--                  </div>-->
                <!--                </div>-->

                <rich-text-view
                    :key="new Date().getTime()"
                    class="content"
                    :content='item&&item.answerContent'
                    :images="item.imageList||[]"
                ></rich-text-view>
              </div>
              <div class="videoDetail" v-if="item.videoList != null">
                <!-- <a-carousel arrows dots-class="slick-dots slick-thumb" :autoplay="autoplay">
                  <a slot="customPaging" slot-scope="props">
                    <img v-if="item.videoList[props.i].coverPath!=null" :src="resBasePath+'/'+item.videoList[props.i].coverPath" />
                  </a>
                  <div class="videoItem" v-for="i in item.videoList" :key="i.id" >
                        <video v-if="i.path.split('.')[1]=='mp4'" class="videoPlay" controlslist="nodownload" :disablePictureInPicture="true" :src="resBaseVideo+'/'+i.path" controls="controls" :poster="i.coverPath"></video>
                        <ts-video :videos="item.videoList"></ts-video>
                    </div>
                </a-carousel> -->
                <!--                <ts-new :videos="item.videoList"></ts-new>-->

                <rich-text-view
                    :key="new Date().getTime()"
                    class="content"
                    :content='item&&item.answerContent'
                    :videos="item.videoList||[]"
                ></rich-text-view>
              </div>
              <div v-if="item.audioList != null" style="text-align:center">
                <!--                <div class="audioDiv" v-for="audio in item.audioList" :key="audio.id">-->
                <!--                  <audio controls class="audioWidth" :src="resBasePath + '/' + audio.path"/>-->
                <!--                  <p v-if="audio.name">{{ '音频' + audio.name }}</p>-->
                <!--                </div>-->

                <rich-text-view
                    :key="new Date().getTime()"
                    class="content"
                    :content='item&&item.answerContent'
                    :audios="item.audioList||[]"
                ></rich-text-view>
              </div>
            </div>
            <!-- <div class="goMapMain" v-if='item.isMap === 1'>
              <div class="goMapText">请点击地图，输入你所在位置，查一查，你所在的位置距离这些标注了小红旗的位置有多远。</div>
              <div class="goMap1" @click="lookMap(item, '1')">
                <a-icon class="loc" type="environment" />
                <span class="text">查看地图</span>
              </div>
            </div> -->
            <div class="task-status">
              <div class="status-l">
                <span class="staTitle">状态:</span>
                <span class="staMain">{{ format.permission(item.permission) }}</span>
              </div>
              <div class="status-r">
                <a-button class="edit" @click="edit(item)" icon="form">编辑</a-button>
                <a-button class="delete" @click="deleted(item.id)" icon="delete">删除</a-button>
              </div>
            </div>
          </div>
          <div class="bgc" v-if="prepareData == null || prepareData.length == 0">
            <a-empty style="padding:80px"/>
          </div>
          <div class="fun">
            <a-button class="add" @click="add" icon="plus">添加</a-button>
          </div>
        </div>
      </div>
      <!--      <div class="right">-->
      <!--        <div class="order">-->
      <!--          <div class="studentLook">-->
      <!--            <a-button class="orderMes" @click="orderRelease" type="primary">发布</a-button>-->
      <!--            <a-tooltip placement="top" :title="tipMess">-->
      <!--              <a-button class="studentView" type="primary" @click="goStudent"><img class="logo"-->
      <!--                     src="../../../assets/imgs/logo2.png" />学生端预览</a-button>-->
      <!--            </a-tooltip>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--        <div class="history">-->
      <!--          <a-button class="resources" @click="goZiYuan()">备课资源</a-button>-->
      <!--          <a-button class="classes" @click="goBeiKe()">备课历史</a-button>-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
    <!--add start-->
    <div>
      <a-modal v-model="addVisible" title="添加学前准备" width="1060px" footer="" destroyOnClose>
        <div class="dalog">
          <div>
            <!-- <a-textarea class="mess" v-model="addParam.content" placeholder="请输入内容..." :auto-size="{ minRows: 4, maxRows: 12 }" /> -->
            <Wangeditor @input="getInput"></Wangeditor>
          </div>
          <div class="imgList" v-if="checkImgList.length > 0">
            <a-row>
              <a-col class="newImg" :span="8" v-for="(item, index) in checkImgList" :key="index">
                <img width="320px" height="190px" :src="resBasePath + '/' + item.path" alt=""/>
                <img class="del" @click="del_img(item)" src="../../../assets/image/27.png" alt="">
              </a-col>
            </a-row>
          </div>
          <div class="videoList" v-if="checkVideoList.length > 0">
            <a-row>
              <a-col class="newImg" :span="8" v-for="(item, index) in checkVideoList" :key="index">
                <video class="addvideoPlay" :src="resBaseVideo + '/' + item.path" controls="controls"
                       controlslist="nodownload" :disablePictureInPicture="true" poster="">
                </video>
                <img class="del" @click="del_video(item)" src="../../../assets/image/27.png" alt="">
              </a-col>
            </a-row>
          </div>
          <div class="audioList" v-if="checkAudioList.length > 0">
            <a-row>
              <a-col class="newImg" :span="8" v-for="item in checkAudioList" :key="item.id">
                <audio class="addvideoPlay" controlslist="nodownload" :src="resBaseVideo + '/' + item.path"
                       controls="controls" poster="">
                </audio>
                <img class="del" @click="del_audio(item)" src="../../../assets/image/27.png" alt="">
              </a-col>
            </a-row>
          </div>
          <div class="goMap" v-if="this.state.state.mapInfo">
            <a-icon class="loc" type="environment"/>
            <span class="text">{{ this.state.state.mapInfo.title }}</span>
          </div>
          <div class="uploadImg">
            <div class="uploadLib" @click="upLoadLib">添加资源</div>
            <!-- <div class="addMap" @click="addMap()">添加地图定位</div> -->
            <a-select default-value="私有" style="width:170px;margin:0px 20px;" @change="addHandleChangeType">
              <a-select-option v-for="(item, index) in selectOpen" :key="index" :value="item.key">
                {{ item.value }}
              </a-select-option>
            </a-select>
            <a-button class="sureButton" @click="addHandleOk">确定</a-button>
          </div>
        </div>
      </a-modal>
    </div>
    <!--add end-->
    <!--edit start-->
    <div v-if="editVisible">
      <a-modal v-model="editVisible" title="编辑学前准备" width="1000px" footer="" destroyOnClose
               @cancel="cancelNewClass">
        <div class="editdalog">
          <div>
            <!-- <a-textarea class="mess" v-model="editMess.content" placeholder="请输入内容..." :auto-size="{ minRows: 4, maxRows: 12 }" /> -->
            <Wangeditor @input="getInput" v-model="editMess.content"></Wangeditor>
          </div>
          <div class="list">
            <a-row class="listRow">
              <div class="listColImg" v-for="(item, index) in editimgTrans" :key="index">
                <img :src="resBasePath + '/' + item.path" alt=""/>
                <img class="del" @click="delImg(index)" src="../../../assets/image/27.png" alt="">
              </div>
            </a-row>
            <a-row>
              <div>
                <div class="editVideo" v-for="(item, index) in editvideoTrans" :key="index">
                  <video class="editvideoPlay" style="outline-style: none;" controlslist="nodownload"
                         :disablePictureInPicture="true" :src="resBaseVideo + '/' + item.path"
                         controls="controls"
                         :poster="item.coverPath && item.coverPath != null ? item.coverPath : '@/assets/imgs/video.png'"></video>
                  <img class="del" @click="editdelVideo(index)" src="../../../assets/image/27.png" alt=""/>
                </div>
              </div>
            </a-row>
            <a-row>
              <div class="editAudio" v-for="(item, index) in editaudioTrans" :key="index">
                <audio class="editvideoPlay" style="outline-style: none;" controlslist="nodownload"
                       :src="resBaseVideo + '/' + item.path" controls="controls" poster="">
                </audio>
                <img class="del" @click="delAudio(index)" src="../../../assets/image/27.png" alt=""/>
              </div>
            </a-row>
            <!-- <div class="goMapMain" v-if='editMess.isMap === 1'>
              <div class="goMapText">请点击地图，输入你所在位置，查一查，你所在的位置距离这些标注了小红旗的位置有多远。</div>
              <div class="goMap1" @click="lookMap(editMess, '2')">
                <a-icon class="loc" type="environment" />
                <span class="text">查看地图</span>
              </div>
            </div> -->
          </div>
          <div class="uploadImg">
            <div class="uploadLib" @click="editupLoadLib">添加资源</div>
            <!-- <div class="addMap" @click="addMap()">添加地图定位</div> -->
            <a-select :default-value="format.permission(editMess.permission)"
                      style="width:170px;margin-left:20px;" @change="editHandleChangeType">
              <a-select-option v-for="(item, index) in selectOpen" :key="index" :value="item.key">
                {{ item.value }}
              </a-select-option>
            </a-select>
            <a-button class="sureButton" @click="editHandleOk(editMess.id)">确定</a-button>
          </div>
        </div>
      </a-modal>
    </div>
    <!--edit end-->
    <a-modal v-model="delVisible" title="删除" @ok="delOk">
      <p>删除后将不可恢复您确认要删除吗？</p>
    </a-modal>
    <a-modal class="classNumber" v-model="release" width="440px" title="" footer="" @ok="delOk">
      <div class="classTop">
        <a-checkbox-group @change="checkClass">
          <div class="classSelect" v-for="(item, index) in classData" :key="index">
            <a-checkbox :value="item.id">{{ item.className }}</a-checkbox>
          </div>
        </a-checkbox-group>
        <div class="classBot">
          <a-button class="cancelButton" @click="release = false">取消</a-button>
          <a-button class="classSureButton" :disabled="disabledClass == false" @click="classSure">确定
          </a-button>
        </div>
      </div>
    </a-modal>
    <!---学生端预览弹窗--->
    <a-modal class="classNumber" v-model="releaseStu" width="440px" title="" footer="">
      <div class="classTop">

        <a-radio-group v-model="lookClassData" @change="onChangeStu">
          <div class="classSelect" v-for="(item, index) in classData" :key="index">
            <a-radio :value="item.id">{{ item.className }}</a-radio>
          </div>
        </a-radio-group>
        <div class="classBot">
          {{ lookClassData }}
          <a-button class="cancelButton" @click="releaseStu = false">取消</a-button>
          <a-button class="classSureButton" @click="classSureStu">确定</a-button>
        </div>
      </div>
    </a-modal>
    <!---学生端预览结束弹窗--->
    <a-modal title="提示" :visible="visible" :confirm-loading="confirmLoading" @ok="handleOk"
             @cancel="handleCancel">
      <p>{{ ModalText }}</p>
    </a-modal>
    <div>
      <a-modal title="地图" destroyOnClose :visible="mapvisible" :zIndex=1001 footer="" width="1050px"
               :confirm-loading="confirmLoading" @cancel="maphandleCancel">
        <Map :mapInfo='mapPositionDetail' :addType='addType' :mapNum='mapNum'></Map>
      </a-modal>
    </div>
    <div v-if="libraryVis">
      <a-modal title="资源" :visible="libraryVis" :zIndex=1001 destroyOnClose footer="" width="950px"
               :confirm-loading="confirmLoading" @cancel="libraryCancel">
        <div class="mainLib">
          <!-- <a-spin class="load" v-show="loading" /> -->
          <div class="sureNum">已选{{ savecheckImg.length + savecheckVideo.length + savecheckAudio.length }}项
          </div>
          <div class="sureImg" @click="sureImg()">使用</div>
          <div class="search">
            <a-input-search v-model="searchName" placeholder="输入搜索内容" enter-button @search="onSearch"/>
          </div>
          <div class="tabList">
            <a-tabs default-active-key="1" @change="tabList">
              <a-tab-pane key="1" tab="图片">
                <a-checkbox-group v-model="savecheckImg" @change="checkedImg">
                  <ul>
                    <li class="uploadLi" @click="uploadPhotoLi"></li>
                    <li v-for="(item, index) in dataList" :key="index">
                      <template>
                        <div class="imgTop">
                          <img slot="extra" :src="resBasePath + '/' + item.filePath" alt=""/>
                        </div>
                        <div class="imgBot">
                          <span class="imgName">{{ item.fileName || '图片' + index }}</span>
                          <a-checkbox :value="item.filePath"></a-checkbox>
                          <!-- <span class="imgDel" @click="delPhoto(item.id)"> <a-icon type="delete" /> </span> -->
                        </div>
                      </template>
                    </li>
                  </ul>
                </a-checkbox-group>
              </a-tab-pane>
              <a-tab-pane key="2" tab="视频" force-render>
                <a-checkbox-group v-model="savecheckVideo" @change="checkedVideoListFun">
                  <ul>
                    <li class="uploadLi" @click="uploadPhotoLi"></li>
                    <li v-for="(item, index) in dataList" :key="index">
                      <template>
                        <div class="imgTop">
                          <video class="video" :src="resBaseVideo + '/' + item.filePath" controls="controls"
                                 controlslist="nodownload" poster=""></video>
                        </div>
                        <div class="imgBot">
                          <span class="imgName">{{ item.fileName || '视频' + index }}</span>
                          <a-checkbox :value="item.filePath"></a-checkbox>
                        </div>
                      </template>
                    </li>
                  </ul>
                </a-checkbox-group>
              </a-tab-pane>
              <a-tab-pane key="5" tab="音频">
                <a-checkbox-group v-model="savecheckAudio" @change="checkedAudioListFun">
                  <ul>
                    <li class="uploadLi" @click="uploadPhotoLi"></li>
                    <li v-for="(item, index) in dataList" :key="index">
                      <template>
                        <div class="imgTop">
                          <video class="video" controlslist="nodownload"
                                 :src="resBaseVideo + '/' + item.filePath" controls="controls"
                                 poster=""></video>
                        </div>
                        <div class="imgBot">
                          <span class="imgName">{{ item.fileName || '音频' + index }}</span>
                          <a-checkbox :value="item.filePath"></a-checkbox>
                          <!-- <span @click="delVideo(item.id)" class="imgDel">
                        <a-icon type="delete" />
                      </span> -->
                        </div>
                      </template>
                    </li>
                  </ul>
                </a-checkbox-group>
              </a-tab-pane>
            </a-tabs>
          </div>
        </div>
      </a-modal>
    </div>
    <a-modal title="添加资源" :visible="uploadShowVis" destroyOnClose :zIndex=1003 footer="" width="450px"
             :confirm-loading="confirmLoading" @cancel="uploadShowCancel">
      <a-row style="min-height:120px;line-height:30px;">
        <!-- <a-col :span="4">
            名称:
          </a-col> -->
        <a-col :span="24">
          <!-- <a-input v-model="photoName" placeholder="请输入内容名称" /> -->
          <div class="photoUpload">
            <a-upload action="" list-type="picture-card" :show-upload-list="true" @preview="handlePreview"
                      :before-upload="beforeUpload1" @change="handleChange">
              <div class="ant-upload-text">上传</div>
            </a-upload>
            <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
              <img alt="example" style="width: 100%" :src="previewImage"/>
            </a-modal>
          </div>
        </a-col>
      </a-row>
    </a-modal>
    <div v-if="lookVis">
      <a-modal class="classNumber" v-model="lookVis" width="440px" title="发布" footer="">
        <div class="classTop">
          <a-radio-group @change="lookCheckClass">
            <div class="classSelect" v-for="(item, index) in classData" :key="index">
              <a-radio :value="item.id">{{ item.className }}</a-radio>
            </div>
          </a-radio-group>
          <div class="classBot">
            <a-button class="cancelButton" @click="lookVis = false">取消</a-button>
            <a-button class="classSureButton" @click="lookSure">确定</a-button>
          </div>
        </div>
      </a-modal>
    </div>
    <a-modal title="预览" class="classNumber" v-model="look" width="1100px"
             @cancel="() => { look = false; lookClassData = '' }" footer="">
      <div class="view">
        <div class="content" style="background: #f8f8f8;">
          <div class="bgc" style="background: #fff;" v-for="(item, index) in prepareDataView" :key="index">
            <div class="message" v-html="item.content"></div>
            <div class="imgView">
              <div v-if="item.imageList != null" style="text-align:center;">
                <a-carousel arrows dots-class="slick-dots slick-thumb" :autoplay="autoplay">
                  <a slot="customPaging" slot-scope="props">
                    <img :src="resBasePath + '/' + item.imageList[props.i].path"/>
                  </a>
                  <div v-for="img in item.imageList" :key="img.id">
                    <img :src="resBasePath + '/' + img.path"/>
                    <p v-if="img.name">{{ img.name }}</p>
                  </div>
                </a-carousel>
              </div>
              <div class="videoDetail" v-if="item.videoList != null" style="text-align:center;">
                <ts-new :videos="item.videoList"></ts-new>
              </div>
              <div v-if="item.audioList != null" style="text-align:center">
                <div class="audioDiv" v-for="audio in item.audioList" :key="audio.id">
                  <audio controls class="audioWidth" :src="resBasePath + '/' + audio.path"/>
                  <p v-if="audio.name">{{ '音频' + audio.name }}</p>
                </div>
              </div>
            </div>
          </div>
          <div v-if="prepareDataView == null || prepareDataView.length == 0">
            <a-empty style="margin-top:80px"/>
          </div>
        </div>
      </div>
    </a-modal>
    <file-preview :visible.sync="preImgVisible" v-if="preImgVisible" :file="previewImg"></file-preview>
  </div>
</template>

<script>
// import HanIcon from 'components/Icon.vue'
import axios from 'axios';
import tsVideo from '../components/tsvideo.vue';
import tsNew from '../components/tsNew.vue';
import Map from '../components/Map.vue';
import format from '../../../utils/format.js';
import state from '@/utils/shareState.js';
import Wangeditor from '../components/Wangeditor.vue';
import DoPractice from "../DoPractice.vue";
import RichTextView from "../../../components/richTextView.vue";
import FilePreview from "../../../components/FilePreview.vue";

export default {
  name: 'ZhunBei',
  components: {
    DoPractice,
    tsVideo,
    tsNew,
    Map,
    Wangeditor,
    FilePreview, RichTextView
  },
  created() {
  },
  data() {
    return {
      look: false,
      state,
      visible: false,
      confirmLoading: false,
      mapvisible: false,
      ModalText: '请先添加活动',
      format,
      disable: false, // 删除准备时剩下一个不允许删除
      resBasePath: this.$resBasePath,
      resBaseVideo: this.$resBaseVideo,
      editMess: {}, // 编辑时候的回显并作为参数去保存编辑
      loading: false,
      selectOpen: [
        {value: '公开', key: '1'},
        {value: '私有', key: '2'},
      ],
      addVisible: false, // 添加dialog显示状态
      editVisible: false, // 编辑dialog显示状态
      delVisible: false, // 删除提示
      release: false, // 发布
      releaseStu: false, // 学生端预览
      prepareData: [],
      prepareDataView: [], // yulan
      // status: '公开', // 准备状态
      previewVisible: false,
      previewImage: '',
      imgList: [], // 展示上传图片的列表,
      videoList: [], // 视频展示列表
      mp3List: [], // 音频列表
      addParam: {
        // 学前准备添加参数集合
        styleId: localStorage.getItem('styleId'),
        bookId: localStorage.getItem('syzg-bookId'),
        readStyleId: '', // 相关阅读id
        content: '', // 内容
        detailContent: '', // 变色内容
        type: '1', // 1：纯文字 2：图片3：视频4：音频 5：相关阅读
        isMap: '', // 是否有地图
        mapInfo: '', // 地图信息
        mapPosition: '', // 地图坐标
        audioPath: '',
        audioList: [],
        imageList: [],
        videoList: [],
        imagePath: '',
        photoCover: '', // 缩略图
        videoPath: '',
        teacherId: this.$getUserInfo().id, // 教师id
        videoPhoto: '',
        isPublish: '0', // 是否发布 1是 0否
        school: '', // 教师所在学校
        permission: '2', // 1：公开 2：私有 3：学校
      },
      delParam: {id: ''},
      classData: [], // 班级信息列表
      orderParam: [], // 选择的发布班级
      classStuId: '', // 预览班级ID
      disabledClass: false,
      // 2021-03-12
      libraryVis: false, // 资源库弹窗
      uploadText: '上传图片',
      uploadPhoto: true,
      uploadVideo: false,
      uploadExcel: false,
      type: '1', // 1图片2视频3文档5音频
      listData: [],
      dataList: [],
      filePath: '', // 图片路径
      fileName: '', // 图片名
      plainOptions: [], // 按钮选择
      // checkNum: '',//选择图片的数量
      checkImgList: [], // 选择的图片
      checkVideoList: [], // 选择的视频
      checkAudioList: [], // 选择的音频
      savecheckImg: [], // 暂存选择的图片
      savecheckVideo: [], // 暂存选择的视频
      savecheckAudio: [], // 暂存选择的音频
      imgTrans: [], // 添加转图片为数组
      videoTrans: [], // 添加转视频为数组
      audioTrans: [], // 添加转音频为数组
      editimgTrans: [], // 编辑转图片为数组
      editvideoTrans: [], // 编辑转视频为数组
      editaudioTrans: [], // 编辑转音频为数组
      uploadShowVis: false, // 上传图片弹窗
      photoName: '', // 上传图片名称
      edit_id: '',
      autoplay: true,
      searchName: '', // 搜索名称
      addType: '1', // 添加资源根据类型添加
      mapPositionDetail: '', // 地图详细信息
      mapNum: '1', // 1代表是打开地图 2.代表是编辑打开地图
      token: '',
      lookClassData: '',
      lookVis: false,
      tipMess: '请您发布成功后再预览！',
      preImgVisible: false,
      previewImg: {},
    };
  },
  mounted() {
    this.token = this.$getUserInfo().access_token || localStorage.getItem('access_token') || '';
    this.getParpre();
    this.getClassNum();
  },
  methods: {
    lookCheckClass(val) {
      this.lookClassData = val.target.value;
    },
    lookSure() {
      if (this.lookClassData == '') {
        this.$message.warning('请选择要预览的班级');
      } else {
        const param = {
          styleId: localStorage.getItem('styleId'),
          userId: this.$getUserInfo().id,
          classId: this.lookClassData,
        };
        const _this = this;
        _this
            .$fetch({
              url: _this.$baseUrl + 'ebook/teacher/study/getTeacherPreStudyPreview',
              body: param,
            })
            .loading(
                () => (_this.loading = true),
                () => (_this.loading = false)
            )
            .done((res) => {
              _this.prepareDataView = res.resultData;
              _this.look = true;
              _this.lookVis = false;
            });
      }
    },
    maphandleCancel() {
      this.mapvisible = false;
    },
    addMap() {
      this.mapvisible = true;
    },
    lookMap(item, num) {
      this.mapNum = num;
      this.mapvisible = true;
      this.mapPositionDetail = item.mapInfo;
    },
    cancelNewClass() {
      this.editVisible = false;
    },
    uploadPhotoLi() {
      this.uploadShowVis = true;
      this.photoName = '';
    },
    uploadShowCancel() {
      this.uploadShowVis = false;
    },
    getParpre() {
      // 获取教师学前准备
      const bookId = localStorage.getItem('syzg-bookId');
      const param = {
        bookId: bookId,
        styleId: localStorage.getItem('styleId'),
        userId: this.$getUserInfo().id,
        delFlag: '0',
      };
      const _this = this;
      _this
          .$fetch({
            url: _this.$baseUrl + 'ebook/teacher/study/getTeacherPreStudy',
            body: param,
          })
          .loading(
              () => (_this.loading = true),
              () => (_this.loading = false)
          )
          .done((res) => {
            if (res && res.success && res.resultCode === 0) {
              _this.prepareData = res.resultData;
            }
          });
    },
    add() {
      this.addType = '1';
      this.addParam.content = '';
      this.addParam.permission = '2';
      this.checkImgList = [];
      this.checkVideoList = [];
      this.checkAudioList = [];
      this.addVisible = true;
      this.state.state.mapInfo = null;
    },
    edit(item) {
      this.addType = '2';
      this.edit_id = item.id;
      this.editMess = '';
      this.editMess = JSON.parse(JSON.stringify(item));
      this.editimgTrans = [];
      this.editvideoTrans = [];
      this.editaudioTrans = [];
      if (this.editMess.imageList != null && this.editMess.imageList.length > 0) {
        this.editimgTrans = JSON.parse(JSON.stringify(item.imageList));
      } else {
        this.editimgTrans = [];
      }
      if (this.editMess.videoList != null && this.editMess.videoList.length > 0) {
        this.editvideoTrans = JSON.parse(JSON.stringify(item.videoList));
      } else {
        this.editvideoTrans = [];
      }
      if (this.editMess.audioList != null && this.editMess.audioList.length > 0) {
        this.editaudioTrans = JSON.parse(JSON.stringify(item.audioList));
      } else {
        this.editaudioTrans = [];
      }
      this.editVisible = true;
    },
    del_img(e) {
      const index = this.checkImgList.findIndex((item) => item.id === e.id);
      this.checkImgList.splice(index, 1);
    },
    del_video(e) {
      const index = this.checkVideoList.findIndex((item) => item.id === e.id);
      this.checkVideoList.splice(index, 1);
    },
    del_audio(e) {
      const index = this.checkAudioList.findIndex((item) => item.id === e.id);
      this.checkAudioList.splice(index, 1);
    },
    delImg(index) {
      this.editimgTrans.splice(index, 1);
    },
    editdelVideo(index) {
      this.editvideoTrans.splice(index, 1);
    },
    delAudio(index) {
      this.editaudioTrans.splice(index, 1);
    },
    delOk() {
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/study/deletePreStudy',
        body: this.delParam,
      })
          .loading(
              () => (this.loading = true),
              () => (this.loading = false)
          )
          .done((res) => {
            if (res && res.success && res.resultCode === 0) {
              this.$message.success('删除成功');
              this.delVisible = false;
            }
            this.getParpre();
          });
    },
    deleted(id) {
      this.delVisible = true;
      this.delParam.id = id;
    },
    addHandleOk() {
      // 新增
      if (this.state.state.mapInfo) {
        this.addParam.isMap = '1';
        this.addParam.mapInfo = this.state.state.mapInfo.point.lng + ',' + this.state.state.mapInfo.point.lat;
      }
      this.addParam.imageList = this.checkImgList;
      this.addParam.videoList = this.checkVideoList;
      this.addParam.audioList = this.checkAudioList;
      if (this.addParam.content == '') {
        this.$message.error('请输入内容');
      } else {
        this.$fetch({
          url: this.$baseUrl + 'ebook/teacher/study/savePreStudyPrepare',
          body: this.addParam,
        })
            .loading(
                () => (this.loading = true),
                () => (this.loading = false)
            )
            .done((res) => {
              if (res && res.success && res.resultCode === 0) {
                this.$message.success('添加成功');
                this.addVisible = false;
                this.getParpre();
              } else {
                this.$message.error(res.resultMessage);
              }
            });
      }
    },
    editHandleOk() {
      // 修改回调
      this.editMess.imageList = this.editimgTrans;
      this.editMess.videoList = this.editvideoTrans;
      this.editMess.audioList = this.editaudioTrans;
      // if (this.editimgTrans != null && this.editimgTrans.length != 0) {
      //   this.editMess.imageList = this.editimgTrans
      // }
      // if (this.editvideoTrans != null && this.editvideoTrans.length != 0) {
      //   this.editMess.videoList = this.editvideoTrans
      // }
      // if (this.editaudioTrans != null && this.editaudioTrans.length != 0) {
      //   this.editMess.audioList = this.editaudioTrans
      // }
      if (this.state.state.mapInfo) {
        this.editMess.isMap = '1';
        this.editMess.mapInfo = this.state.state.mapInfo.point.lng + ',' + this.state.state.mapInfo.point.lat;
      }
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/study/savePreStudyPrepare',
        body: this.editMess,
      })
          .loading(
              () => (this.loading = true),
              () => (this.loading = false)
          )
          .done((res) => {
            if (res && res.success && res.resultCode === 0) {
              this.$message.success('编辑成功');
              this.editVisible = false;
              this.getParpre();
            } else {
              this.$message.error(res.resultMessage);
            }
          });
    },
    addHandleChangeType(e) {
      this.addParam.permission = e;
    },
    editHandleChangeType(e) {
      this.editMess.permission = e;
    },
    goZiYuan() {
      // 跳转资源推荐
      this.$router.push({path: '/books/prepareRecommend/'});
    },
    goBeiKe() {
      // 跳转备课历史
      this.$router.push({path: '/books/beiKe/'});
    },
    handleCancel() {
      this.previewVisible = false;
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    handleChange(info) {
      if (info.file.status === 'uploading') {
        this.loading = true;
        return;
      }
      if (info.file.status === 'done') {
        // Get this url from response in real world.
        getBase64(info.file.originFileObj, (imageUrl) => {
          this.imageUrl = imageUrl;
          this.loading = false;
        });
      }
    },
    beforeUpload(file) {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('customDir', 'hytc_ebook_server/file');
      formData.append('access_token', this.token || '');
      const _this = this;
      // 上传图片方法
      axios({
        url: _this.$uploadUrl,
        method: 'post',
        data: formData,
        headers: {'Content-Type': 'multipart/form-data'},
      }).then((res) => {
        if (res && res.status === 200) {
          const result = /\.[^\.]+/.exec(res.data.url)[0];
          if (result == '.mp4') {
            _this.videoList.push({
              id: res.data.id,
              url: res.data.url,
            });
            _this.videoList.map((item) => {
              _this.addParam.videoList.push({path: '/' + item.url});
            });
          }
          if (result == '.mp3') {
            _this.mp3List.push({
              id: res.data.id,
              url: res.data.url,
            });
            _this.mp3List.map((item) => {
              _this.addParam.audioList.push({path: '/' + item.url});
            });
          }
          if (result == '.jpg' || result == '.jpeg' || result == '.png') {
            _this.imgList.push({
              id: res.data.id,
              url: res.data.url,
            });
            _this.imgList.map((item) => {
              _this.addParam.imageList.push({path: '/' + item.url});
            });
          } else {
            _this.$message.error('不支持此格式');
          }
        }
      });
    },
    orderRelease() {
      // 发布
      if (this.classData != null && this.classData.length > 0) {
        if (localStorage.getItem('studyTaskNum') == 0) {
          this.$message.warning('学习任务不能为空');
        } else {
          this.release = true;
        }
      } else {
        this.$message.warning('暂无发布班级信息');
      }
    },
    checkClass(val) {
      this.orderParam = val;
      if (this.orderParam.length > 0) {
        this.disabledClass = true;
      } else {
        this.disabledClass = false;
      }
    },
    getClassNum() {
      this.$fetch({
        url: this.$baseUrl + 'ebook/class/v3/common/getSimpleClaList',
        body: {userId: this.$getUserInfo().id}
      }).done(res => {
        if (res && res.success && res.resultCode === '0') {
          this.classData = res.resultData
        }
      })
    },
    handleOk(e) {
      this.visible = false;
      this.confirmLoading = false;
    },
    handleCancel(e) {
      this.visible = false;
      this.previewVisible = false;
    },
    classSure() {
      if (this.prepareData.length === 0) {
        this.visible = true;
        this.release = false;
      } else {
        const param = {
          styleId: localStorage.getItem('styleId'),
          teacherId: this.$getUserInfo().id,
          classIds: this.orderParam,
        };
        this.$fetch({
          url: this.$baseUrl + 'ebook/teacher/push/publishToClass',
          body: param,
        })
            .loading(
                () => (this.loading = true),
                () => (this.loading = false)
            )
            .done((res) => {
              if (res && res.success && res.resultCode === 0) {
                this.$message.success('发布成功');
                this.release = false;
              } else {
                this.$message.error(res.resultMessage);
              }
            });
      }
    },
    classSureStu() {
      if (!this.classStuId) {
        this.$message.warning('请您选择班级预览');
        return false;
      } else {
        this.releaseStu = false;
        window.open(this.$studentUrl + '#/books/learning-pre/' + localStorage.getItem('styleId'));
      }
    },
    goStudent() {
      this.lookVis = true;
      // if(this.orderParam.length<1){
      //   this.$message.warning('暂无发布预览班级信息')
      // }else{
      //   window.open(this.$studentUrl + '#/books/learning-pre/' + localStorage.getItem('styleId'))
      // }
    },
    tabList(key) {
      switch (key) {
        case '1':
          this.type = 1;
          this.loading = true;
          this.getList();
          break;
        case '2':
          this.type = 2;
          this.loading = true;
          this.getList();
          break;
        case '5':
          this.type = 5;
          this.loading = true;
          this.getList();
          break;
        default:
          this.type = 1;
      }
    },
    getList() {
      const param = {
        teacherId: this.$getUserInfo().id,
        type: this.type,
        styleId: localStorage.getItem('styleId'),
        fileName: this.searchName,
      };
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/base/getTeacherResourceBase',
        body: param,
      })
          .loading(
              () => (this.loading = true),
              () => (this.loading = false)
          )
          .done((res) => {
            this.dataList = res.resultData;
            this.plainOptions = res.resultData;
            // this.newImgList = res.resultData
            this.loading = false;
          });
    },
    delPhoto(id) {
      const param = {id: id};
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/base/deleteBaseResource',
        body: param,
      })
          .loading(
              () => (this.loading = true),
              () => (this.loading = false)
          )
          .done((res) => {
            if (res && res.success) {
              this.$message.success('删除成功');
              this.getList();
            }
          });
    },
    delVideo(id) {
      const param = {id: id};
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/base/deleteBaseResource',
        body: param,
      })
          .loading(
              () => (this.loading = true),
              () => (this.loading = false)
          )
          .done((res) => {
            if (res && res.success) {
              this.$message.success('删除成功');
              this.getList();
            }
          });
    },
    delDoc(id) {
      const param = {id: id};
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/base/deleteBaseResource',
        body: param,
      })
          .loading(
              () => (this.loading = true),
              () => (this.loading = false)
          )
          .done((res) => {
            if (res && res.success) {
              this.$message.success('删除成功');
              this.getList();
            }
          });
    },
    beforeUpload1(file) {
      // console.log(1111, file);
      // console.log(this.type);
      if (file == null) {
        this.$message.warning('请选择文件');
        return;
      }
      if (this.type == 1 && file.type != 'image/png' && file.type != 'image/jpeg') {
        this.$message.warning('请您上传正确的格式，支持PNG、JPG格式');
        return;
      } else if (this.type == 2 && file.type != 'video/mp4') {
        this.$message.warning('请您上传正确的格式，支持mp4格式');
        return;
      } else if (this.type == 5 && file.type != 'audio/mpeg') {
        this.$message.warning('请您上传正确的格式，支持mp3格式');
        return;
      }
      const formData = new FormData();
      formData.append('file', file);
      formData.append('customDir', 'hytc_ebook_server/file');
      formData.append('access_token', this.token || '');
      this.photoName = file.name;
      // 上传图片方法;
      const _this = this;
      axios({
        url: _this.$uploadUrl,
        method: 'post',
        data: formData,
        headers: {'Content-Type': 'multipart/form-data'},
      }).then((res) => {
        if (res && res.status === 200) {
          _this.uploadCommon(_this.type, res.data.url, _this.photoName);
          setTimeout(() => {
            _this.getList();
          }, 1000);
        }
      });
    },
    uploadCommon(type, url, fileName) {
      const param = {
        teacherId: this.$getUserInfo().id,
        type: type,
        filePath: url,
        fileName: fileName,
      };
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/base/saveBaseResource',
        body: param,
      })
          .loading(
              () => (this.loading = true),
              () => (this.loading = false)
          )
          .done((res) => {
            this.$message.success('上传成功');
            this.loading = false;
            this.uploadShowVis = false;
          });
    },
    handleChange(info) {
      if (info.file.status === 'uploading') {
        this.loading = true;
        return;
      }
      if (info.file.status === 'done') {
        // Get this url from response in real world.
        getBase64(info.file.originFileObj, (imageUrl) => {
          this.imageUrl = imageUrl;
          this.loading = false;
        });
      }
    },
    upLoadLib() {
      // this.addType = 1
      this.savecheckImg = [];
      this.savecheckVideo = [];
      this.savecheckAudio = [];
      this.libraryVis = true;
      this.searchName = '';
      const param = {
        teacherId: this.$getUserInfo().id,
        type: 1,
        styleId: localStorage.getItem('styleId'),
      };
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/base/getTeacherResourceBase',
        body: param,
      })
          .loading(
              () => (this.loading = true),
              () => (this.loading = false)
          )
          .done((res) => {
            this.dataList = res.resultData;
            this.plainOptions = res.resultData;
            this.loading = false;
          });
    },
    editupLoadLib() {
      // 编辑学前准备资源库展示
      // this.addType = 2
      const param = {
        teacherId: this.$getUserInfo().id,
        type: 1,
        styleId: localStorage.getItem('styleId'),
      };
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/base/getTeacherResourceBase',
        body: param,
      })
          .loading(
              () => (this.loading = true),
              () => (this.loading = false)
          )
          .done((res) => {
            this.dataList = res.resultData;
            this.plainOptions = res.resultData;
            this.loading = false;
          });
      this.savecheckImg = [];
      this.savecheckVideo = [];
      this.savecheckAudio = [];
      this.libraryVis = true;
    },
    libraryCancel() {
      this.libraryVis = false;
    },
    checkedImg(e) {
      this.savecheckImg = e;
      // 转格式
      const newImgList1 = [];
      const newImgList = [];
      for (let i = 0; i < this.dataList.length; i++) {
        const element = this.dataList[i];
        for (let j = 0; j < this.savecheckImg.length; j++) {
          const ele = this.savecheckImg[j];
          if (element.filePath == ele) {
            newImgList1.push(element);
          }
        }
      }
      newImgList1.forEach((item) => {
        newImgList.push({
          path: item.filePath,
          coverPath: '',
          id: '',
          thumbnaiPath: '',
          timeLength: '',
          name: (item.fileName && item.fileName.replace(/(.*\/)*([^.]+).*/gi, '$2')) || '图片.png',
        });
      });
      this.imgTrans = newImgList;
    },
    checkedVideoListFun(e) {
      this.savecheckVideo = e;
      // 转格式
      const newVideoList1 = [];
      const newVideoList = [];
      for (let i = 0; i < this.dataList.length; i++) {
        const element = this.dataList[i];
        for (let j = 0; j < this.savecheckVideo.length; j++) {
          const ele = this.savecheckVideo[j];
          if (element.filePath == ele) {
            newVideoList1.push(element);
          }
        }
      }
      newVideoList1.forEach((item) => {
        newVideoList.push({
          path: item.filePath,
          coverPath: '',
          id: '',
          thumbnaiPath: '',
          timeLength: '',
          name: (item.fileName && item.fileName.replace(/(.*\/)*([^.]+).*/gi, '$2')) || '视频.mp4',
        });
      });
      this.videoTrans = newVideoList; // 把转换为新的数组复制给变量数组
    },
    checkedAudioListFun(e) {
      this.savecheckAudio = e;
      // 转格式
      const newAudioList1 = [];
      const newAudioList = [];
      for (let i = 0; i < this.dataList.length; i++) {
        const element = this.dataList[i];
        for (let j = 0; j < this.savecheckAudio.length; j++) {
          const ele = this.savecheckAudio[j];
          if (element.filePath == ele) {
            newAudioList1.push(element);
          }
        }
      }
      newAudioList1.forEach((item) => {
        newAudioList.push({
          path: item.filePath,
          coverPath: '',
          id: '',
          thumbnaiPath: '',
          timeLength: '',
          name: (item.fileName && item.fileName.replace(/(.*\/)*([^.]+).*/gi, '$2')) || '音频.mp3',
        });
      });
      this.audioTrans = newAudioList; // 把转换为新的数组复制给变量数组
    },
    sureImg() {
      const number = this.savecheckImg.length + this.savecheckVideo.length + this.savecheckAudio.length
      if (number > 9) {
        this.$message.error('最多选择9项内容')
        return
      }
      if (this.addType == 1) {
        // 新增弹窗
        this.checkImgList = this.imgTrans;
        this.checkVideoList = this.videoTrans;
        this.checkAudioList = this.audioTrans;
      }
      if (this.addType == 2) {
        // 编辑弹窗
        this.editimgTrans = [...this.editimgTrans, ...this.imgTrans];
        this.editvideoTrans = [...this.editvideoTrans, ...this.videoTrans];
        this.editaudioTrans = [...this.editaudioTrans, ...this.audioTrans];
      }

      this.imgTrans = [];
      this.videoTrans = [];
      this.audioTrans = [];
      this.libraryVis = false;
    },
    onSearch() {
      if (this.searchName == '') {
        this.$message.error('请输入查询内容');
      } else {
        this.getList();
      }
    },
    onChangeStu(e) {
      this.classStuId = e.target.value;
    },
    getInput(val) {
      this.addParam.content = val;
    },
    preview(img) {
      this.previewImg = {
        name: img.name,
        url: this.resBasePath + '/' + img.path
      }
      this.preImgVisible = true
    },
  },
};

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}
</script>
<style lang="less" scoped>
ul,
li {
  margin: 0;
  padding: 0;
  list-style: none;
}

.main {
  // width: 1240px;
  //padding-right: 20px;
  margin: 0px 20px;
  border-radius: @border-radius-base;

  .load {
    position: absolute;
    top: 45%;
    left: 50%;
    transform: translate(50%, 50%);
    z-index: 99;
  }

  .top {
    // height:400px;
    // height: 100%;
    // display: flex;
    height: calc(100vh - 185px);
    //max-height: calc(100vh - 185px);
    overflow-y: auto;
    background: #fff;
    padding: 20px 30px;
    margin-top: 20px;
    border-radius: @border-radius-base;
    padding-bottom: 20px;

    .title {
      display: flex;
      margin: 0 auto;

      .t-l {
        color: #333;
        font-size: 16px;
        font-weight: 600;
      }

      .t-r {
        margin-left: auto;
        align-content: center;
        text-align: center;
        font-size: 14px;
        color: #d7d7d7;

        .use-his {
          color: @primary-color;
          cursor: pointer;
          // margin-right: 15px;
          text-align: center;
        }

        .pre {
          color: @primary-color;
          cursor: pointer;
          text-align: center;
          width: 4.45vw;
          height: 1.67vw;
        }

        .has-ep {
          width: 80px;
          text-align: center;
          line-height: 24px;
          background: @primary-color;
          border-radius: 2px;
          border: 1px solid @primary-color;
          color: #fff;
          margin-left: 20px;
        }

        .add-pre {
          display: inline-block;
          width: 80px;
          height: 24px;
          line-height: 24px;
          background: @primary-color;
          border-radius: 2px;
          color: #fff;
          text-align: center;
          margin-left: 20px;
          cursor: pointer;

          .add-img {
            width: 16px;
            height: 16px;
          }

          .add-text {
            margin-left: 5px;
          }
        }
      }
    }

    .left {
      flex: 20;
      // width: 1035px;
      border-radius: 12px;
      min-height: 400px;

      .content {
        width: 100%;
        //height: 700px;
        overflow-y: auto;

        .bgc {
          background: #F1F0F0;
          min-height: 150px;
          border-radius: 12px;
          margin-bottom: 20px;

          .message {
            //background: #f8f8f8;
            margin-top: 20px;
            color: #000;
            font-size: 16px;
            // letter-spacing: 0px;
            padding: 20px 35px 10px 35px;
            line-height: 30px;
            font-weight: normal;
            //  margin-top: 12px;
            border-radius: 8px;
          }

          .imgView {
            width: 100%;
            padding: 10px 50px;
            //margin-top: 20px;
            height: 100%;
            display: block;
            //margin-bottom: 50px;

            .videoPlay {
              height: 150px;
              width: 100%;
              outline-style: none;
            }

            .img {
              height: 150px;
              width: 100%;
              outline-style: none;
            }
          }

          .goMapMain {
            .goMapText {
              font-family: PingFangSC-Regular;
              font-size: 20px;
              font-weight: normal;
              font-stretch: normal;
              line-height: 40px;
              height: 40px;
              letter-spacing: 0px;
              color: #000000;
              text-indent: 50px;
              margin-top: 10px;
            }
          }

          .task-status {
            //text-align: right;
            //height: 60px;
            //line-height: 60px;
            display: flex;
            border-top: 1px solid #DBDBDB;
            padding-top: 10px;
            padding-bottom: 10px;
            //padding-right: 20px;
            margin: 0 20px;

            .status-l {
              font-size: 14px;
              margin-left: 20px;
              margin-top: 6px;

              .staTitle {
                font-size: 14px;
                color: #867D7BFF;
              }

              .staMain {
                font-size: 14px;
                color: @primary-color;
                margin-left: 10px;
              }
            }

            .status-r {
              margin-left: auto;

              span {
                color: @primary-color;
                cursor: pointer;
                display: inline-block;
                width: 80px;
                height: 24px;
                line-height: 24px;
                text-align: center;
                border-radius: 2px;
                border: 1px solid @primary-color;
                margin-left: 8px;
              }

              .no-e {
                width: 80px;
                text-align: center;
                line-height: 24px;
                background: #F1F0F0;
                border-radius: 2px;
                border: 1px solid #bdbdbd;
                color: #bdbdbd;
              }

              .has-e {
                width: 80px;
                text-align: center;
                line-height: 24px;
                background: #F1F0F0;
                border-radius: 2px;
                border: 1px solid @primary-color;
                color: @primary-color;
              }

              .studentView {
                width: 120px;
                height: 40px;
                border-radius: 8px;
                margin-top: 20px;
                margin-left: -30px;
                background: #f8f8f8;
                color: #000;
                border: none;

                .logo {
                  width: 20px;
                  height: 20px;
                  margin-top: -4px;
                  margin-right: 8px;
                  margin-left: -10px;
                }
              }
            }

            .operate {
              text-align: right;
            }

            .status {
              padding: 20px 20px 0px 20px;

              .staTitle {
                font-size: 14px;
                color: #867D7BFF;
              }

              .staMain {
                font-size: 14px;
                color: @primary-color;
                margin-left: 10px;
              }
            }

            .edit {
              width: 80px;
              text-align: center;
              line-height: 24px;
              background: #F1F0F0;
              border-radius: 2px;
              border: 1px solid @primary-color;
              color: @primary-color;
              margin-right: 20px;
            }

            .delete {
              width: 80px;
              text-align: center;
              line-height: 24px;
              background: #F1F0F0;
              border-radius: 2px;
              border: 1px solid #fa5542;
              color: #db5647;
            }
          }
        }
      }
    }

    .right {
      flex: 4;
      margin-left: 20px;

      .order {
        height: 160px;
        background: #fff;
        border-radius: 12px;

        .studentLook {
          flex: 4;
          height: 160px;
          background: #fff;
          margin-left: 30px;
          border-radius: 12px;
          text-align: center;

          .orderMes {
            width: 120px;
            height: 40px;
            border-radius: 8px;
            background-image: linear-gradient(122deg, #ff8d46 0%, #fa5542 100%);
            margin-top: 20px;
            margin-left: -30px;
          }

          .studentView {
            width: 120px;
            height: 40px;
            border-radius: 8px;
            margin-top: 20px;
            margin-left: -30px;
            background: #f8f8f8;
            color: #000;
            border: none;

            .logo {
              width: 20px;
              height: 20px;
              margin-top: -4px;
              margin-right: 8px;
              margin-left: -10px;
            }
          }
        }
      }

      .history {
        height: 160px;
        margin-top: 20px;
        background: #fff;
        border-radius: 12px;
        text-align: center;

        .resources {
          width: 120px;
          height: 48px;
          margin-top: 20px;
          color: #22c190;
          font-size: 18px;
        }

        .classes {
          width: 120px;
          height: 48px;
          margin-top: 20px;
          color: @primary-color;
          font-size: 18px;
        }
      }
    }
  }

  .fun {
    margin: 30px 0px 30px 0px;
    display: flex;

    .button {
      flex: 20;
    }
  }
}

.dalog,
.editdalog {
  .mess {
    width: 1000px;
    height: 150px;
    border: 1px solid #e1d9c2;
    background-color: #f8f8f8;
    padding: 20px 30px 0px 30px;

    p {
      color: #000;
      letter-spacing: 0px;
      font-size: 16px;
      line-height: 32px;
    }
  }

  .imgList {
    margin-top: 20px;
    min-height: 150px;
  }

  .uploadImg {
    margin-top: 20px;
    display: flex;

    .uploadLib {
      cursor: pointer;
      width: 120px;
      height: 32px;
      line-height: 32px;
      text-align: center;
      background-color: #a3af90;
      border-radius: 4px;
      color: #fff;
    }

    .addMap {
      cursor: pointer;
      width: 120px;
      height: 32px;
      line-height: 32px;
      text-align: center;
      background-color: @primary-color;
      border-radius: 4px;
      color: #fff;
      margin-left: 20px;
    }
  }
}

.add {
  width: 120px;
  height: 40px;
  color: #a3af90;
  font-size: 16px;
}

.sureButton {
  width: 120px;
  height: 30px;
  background: @primary-color;
  color: #fff;
  margin-left: auto;
}

// /deep/.ant-upload-list-picture .ant-upload-list-item-error,
// .ant-upload-list-picture-card .ant-upload-list-item-error {
//   border-color: #fff;
// }

.editdalog {
  .list {
    width: 100%;
    min-height: 180px;
    margin: 10px 0px;

    .listRow {
      width: 100%;

      .listCol {
        position: relative;
        width: 33.33%;
        height: 120px;

        img {
          height: 180px;
          width: 250px;
        }

        .videoPlay {
          height: 180px;
          width: 100%;
          outline-style: none;
        }

        .del {
          display: none;
          width: 20px;
          height: 20px;
          z-index: 99;
          position: absolute;
          right: 6px;
          top: 6px;
        }

        &:hover {
          .del {
            display: block;
            cursor: pointer;
          }
        }
      }
    }
  }
}

.editVideo,
.editAudio {
  position: relative;
  width: 33%;
  height: 150px;
  display: inline-block;
  text-align: center;

  .editvideoPlay {
    width: 290px;
    height: 150px;
  }

  .del {
    display: none;
    width: 20px;
    height: 20px;
    z-index: 99;
    position: absolute;
    right: 16px;
    top: 6px;
  }

  &:hover {
    .del {
      display: block;
      cursor: pointer;
    }
  }
}

.classNumber {
  min-height: 260px;

  .classTop {
    .classSelect {
      height: 40px;
      line-height: 40px;
    }
  }

  .classBot {
    height: 40px;
    line-height: 40px;
    margin-top: 10px;

    .cancelButton {
      width: 180px;
    }

    .classSureButton {
      width: 180px;
      background: @primary-color;
      color: #fff;
      margin-left: 10px;
    }
  }

  // /deep/.ant-modal-close-x {
  //   display: none;
  // }
}

/deep/ .ant-checkbox + span {
  font-size: 20px;
  color: #040506;
  font-size: 18px;
  font-family: PingFangSC-Regular;
  padding-left: 20px;
}

//2021-03-12
.mainLib {
  background-color: @white;
  border-radius: @border-radius-base;
  //   width: 1240px;
  margin: 0 auto;
  margin-bottom: 30px;
  position: relative;

  .load {
    position: absolute;
    top: 45%;
    left: 50%;
    transform: translate(50%, 50%);
    z-index: 99;
  }

  .sureNum {
    width: 140px;
    height: 44px;
    text-align: center;
    line-height: 44px;
    color: #9d9292;
    font-size: 16px;
    position: absolute;
    right: 130px;
    top: 30px;
  }

  .sureImg {
    cursor: pointer;
    z-index: 99;
    width: 140px;
    height: 44px;
    text-align: center;
    line-height: 44px;
    background-color: @primary-color;
    border-radius: 8px;
    color: #fff;
    font-size: 16px;
    position: absolute;
    right: 0px;
    top: 30px;
  }

  .upLoad {
    display: flex;
    position: absolute;
    right: 10px;
    top: 30px;
    z-index: 9;

    .textLeft {
      width: 100px;
      height: 30px;
      line-height: 30px;
      margin-top: 20px;
      color: #040506;
      font-size: 20px;
      letter-spacing: 5px;
    }

    .imgSize {
      width: 80px;
      height: 80px;
      border-radius: 50%;
    }
  }

  .imgTop {
    width: 275px;
    height: 157px;

    .video {
      width: 100%;
      height: 157px;
    }

    img {
      width: 100%;
      height: 157px;
    }
  }

  .imgBot {
    display: flex;
    margin-top: 10px;
    width: 275px;

    .imgName {
      flex: 22;
      color: #9d9292;
      font-size: 16px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;

      .usePhoto {
        height: 22px;
        line-height: 22px;
      }
    }

    .imgDel {
      color: #db5647;
      flex: 2;
      text-align: right;
      font-size: 16px;
      cursor: pointer;
    }
  }

  .search {
    width: 60%;
    height: 50px;
  }

  .tabList {
    min-height: 400px;

    .upload {
      display: inline-block;
      width: 50%;
      color: #a3af90;

      &:hover {
        cursor: pointer;
      }
    }

    .del {
      display: inline-block;
      width: 50%;
      color: #db5647;

      &:hover {
        cursor: pointer;
      }
    }

    ul {
      li {
        float: left;
        width: 275px;
        margin-right: 20px;
      }

      li:nth-child(3n) {
        margin-right: 0px;
      }

      /deep/ .ant-checkbox-group {
        width: 902px;
      }
    }

    .uploadLi {
      background-image: url('../../../assets/image/upload.png');
      background-size: cover;
      width: 275px;
      height: 157px;
      margin-right: 20px;
      cursor: pointer;
    }
  }
}

// /deep/.ant-upload.ant-upload-select-picture-card {
//     border: none;
//     background: #fff;
//     height: 30px;
// /}
//2021-03-12
.newImg {
  margin-top: 10px;
  position: relative;

  .del {
    display: none;
    width: 20px;
    height: 20px;
    z-index: 99;
    position: absolute;
    right: 16px;
    top: 6px;
  }

  &:hover {
    .del {
      display: block;
      cursor: pointer;
    }
  }
}

.listColImg {
  position: relative;
  display: inline-block;
  width: 33%;
  text-align: center;

  img {
    width: 290px;
    height: 150px;
  }

  .del {
    display: none;
    width: 20px;
    height: 20px;
    z-index: 99;
    position: absolute;
    right: 16px;
    top: 6px;
  }

  &:hover {
    .del {
      display: block;
      cursor: pointer;
    }
  }
}

.videoList {
  .addvideoPlay {
    width: 320px;
    height: 190px;
  }
}

.photoUpload {
  margin-top: 10px;
  height: 150px;
}

.goMapText {
  font-family: PingFangSC-Regular;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 40px;
  height: 40px;
  letter-spacing: 0px;
  color: #000000;
  text-indent: 50px;
  margin-top: 10px;
}

.goMap,
.goMap1 {
  cursor: pointer;
  width: 150px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  height: 44px;
  line-height: 44px;
  background-color: #db5647;
  border-radius: 22px;
  margin-top: 10px;

  .loc {
    font-size: 24px;
    color: #fff;
    margin-left: 18px;
  }

  .text {
    font-size: 18px;
    color: #fff;
    margin-left: 5px;
  }
}

.goMap1 {
  margin-left: 50px;
}

/deep/ .ant-carousel {
  text-align: center;
  width: 300px;
  margin-left: 0;
  //margin: auto;
}

.videoDetail {

  .videoItem {
    display: inline-block;
    width: 640px;

    .videoPlay {
      width: 100%;
      height: 450px;
    }
  }
}

.audioDiv {
  margin: 10px 0px;

  .audioWidth {
    width: 500px;
  }
}

/deep/ .ant-carousel .slick-slide img {
  border: 5px solid #fff;
  display: block;
  margin: auto;
  // width: 100%;
  // height: auto;
}

// /deep/.ant-carousel  .slick-thumb {
//   bottom: -45px;
// }
/deep/ .ant-carousel .slick-thumb li {
  width: 60px;
  height: 45px;
}

/deep/ .ant-carousel .slick-thumb li img {
  border: 2px solid #ccc;
  width: 100%;
  max-height: 300px;
  filter: grayscale(100%);
}

/deep/ .ant-carousel .slick-thumb li.slick-active img {
  border: 2px solid #db5647;
  filter: grayscale(0%);
}

.view {
  .content {
    width: 100%;
    height: 700px;
    overflow-y: auto;

    .bgc {
      background: #fff;
      min-height: 150px;
      margin-top: 10px;

      .status {
        padding: 20px 50px 0px 50px;

        .staTitle {
          font-size: 22px;
          color: #bdbdbd;
        }

        .staMain {
          font-size: 22px;
          color: #000;
          margin-left: 30px;
        }
      }

      .message {
        margin: 0 20px;
        color: #000;
        font-size: 18px;
        letter-spacing: 0px;
        padding: 15px 15px;
        line-height: 30px;
        font-weight: normal;
        margin-top: 12px;
      }

      .imgView {
        width: 60px;
        height: 60px;
        padding: 0 20px;
        margin-top: 20px;
        //height: 100%;
        display: block;

        .videoPlay {
          height: 150px;
          width: 100%;
          outline-style: none;
        }

        img {
          // width: 100%;
          width: 60px;
          height: 60px;
        }
      }

      .goMapMain {
        .goMapText {
          font-family: PingFangSC-Regular;
          font-size: 20px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 40px;
          height: 40px;
          letter-spacing: 0px;
          color: #000000;
          text-indent: 50px;
          margin-top: 10px;
        }
      }

      .caozuo {
        text-align: right;
        height: 60px;
        line-height: 60px;

        .edit {
          width: 120px;
          height: 40px;
          color: @primary-color;
          font-size: 16px;
          margin-right: 20px;
        }

        .delete {
          width: 120px;
          height: 40px;
          color: #db5647;
          font-size: 16px;
          margin-right: 20px;
        }
      }
    }
  }
}

.img-height {
  height: 80px;
  width: 100px;
  margin: 0px 10px;
  border-radius: 8px;
  border: solid 1px #ccc;
  object-fit: cover;
  text-align: center;
}
</style>
